<template>
  <div class="animation-content modal-content portfolio__wrap">
    <div class="portfolio">
      <div class="img-item"><img src="../assets/img/presentation/1920/01_abe_01.jpg" srcset="../assets/img/presentation/1920/01_abe_01.jpg 1920w, ../assets/img/presentation/3840/01_abe_01.jpg 3840w" ></div>
      <div class="img-item"><img src="../assets/img/presentation/1920/01_abe_02.jpg" srcset="../assets/img/presentation/1920/01_abe_02.jpg 1920w, ../assets/img/presentation/3840/01_abe_02.jpg 3840w" ></div>
      <div class="img-item"><img src="../assets/img/presentation/1920/01_abe_03.jpg" srcset="../assets/img/presentation/1920/01_abe_03.jpg 1920w, ../assets/img/presentation/3840/01_abe_03.jpg 3840w" ></div>
      <div class="img-item"><img src="../assets/img/presentation/1920/01_abe_04.jpg" srcset="../assets/img/presentation/1920/01_abe_04.jpg 1920w, ../assets/img/presentation/3840/01_abe_04.jpg 3840w" ></div>
      <div class="img-item"><img src="../assets/img/presentation/1920/01_abe_05.jpg" srcset="../assets/img/presentation/1920/01_abe_05.jpg 1920w, ../assets/img/presentation/3840/01_abe_05.jpg 3840w" ></div>
      <div class="img-item"><img src="../assets/img/presentation/1920/01_abe_06.jpg" srcset="../assets/img/presentation/1920/01_abe_06.jpg 1920w, ../assets/img/presentation/3840/01_abe_06.jpg 3840w" ></div>
      <div class="img-item"><img src="../assets/img/presentation/1920/01_abe_07.jpg" srcset="../assets/img/presentation/1920/01_abe_07.jpg 1920w, ../assets/img/presentation/3840/01_abe_07.jpg 3840w" ></div>
      <div class="img-item"><img src="../assets/img/presentation/1920/01_abe_08.jpg" srcset="../assets/img/presentation/1920/01_abe_08.jpg 1920w, ../assets/img/presentation/3840/01_abe_08.jpg 3840w" ></div>
      <div class="img-item"><img src="../assets/img/presentation/1920/01_abe_09.jpg" srcset="../assets/img/presentation/1920/01_abe_09.jpg 1920w, ../assets/img/presentation/3840/01_abe_09.jpg 3840w" ></div>
      <div class="img-item"><img src="../assets/img/presentation/1920/01_abe_10.jpg" srcset="../assets/img/presentation/1920/01_abe_10.jpg 1920w, ../assets/img/presentation/3840/01_abe_10.jpg 3840w" ></div>
      <div class="img-item"><img src="../assets/img/presentation/1920/01_abe_11.jpg" srcset="../assets/img/presentation/1920/01_abe_11.jpg 1920w, ../assets/img/presentation/3840/01_abe_11.jpg 3840w" ></div>
      <div class="img-item"><img src="../assets/img/presentation/1920/01_abe_12.jpg" srcset="../assets/img/presentation/1920/01_abe_12.jpg 1920w, ../assets/img/presentation/3840/01_abe_12.jpg 3840w" ></div>
      <div class="img-item"><img src="../assets/img/presentation/1920/01_abe_13.jpg" srcset="../assets/img/presentation/1920/01_abe_13.jpg 1920w, ../assets/img/presentation/3840/01_abe_13.jpg 3840w" ></div>
      <div class="img-item"><img src="../assets/img/presentation/1920/01_abe_14.jpg" srcset="../assets/img/presentation/1920/01_abe_14.jpg 1920w, ../assets/img/presentation/3840/01_abe_14.jpg 3840w" ></div>
      <div class="img-item"><img src="../assets/img/presentation/1920/01_abe_15.jpg" srcset="../assets/img/presentation/1920/01_abe_15.jpg 1920w, ../assets/img/presentation/3840/01_abe_15.jpg 3840w" ></div>
      <div class="img-item"><img src="../assets/img/presentation/1920/01_abe_16.jpg" srcset="../assets/img/presentation/1920/01_abe_16.jpg 1920w, ../assets/img/presentation/3840/01_abe_16.jpg 3840w" ></div>
      <div class="img-item"><img src="../assets/img/presentation/1920/01_abe_17.jpg" srcset="../assets/img/presentation/1920/01_abe_17.jpg 1920w, ../assets/img/presentation/3840/01_abe_17.jpg 3840w" ></div>
      <div class="img-item"><img src="../assets/img/presentation/1920/01_abe_18.jpg" srcset="../assets/img/presentation/1920/01_abe_18.jpg 1920w, ../assets/img/presentation/3840/01_abe_18.jpg 3840w" ></div>
      <div class="img-item"><img src="../assets/img/presentation/1920/01_abe_19.jpg" srcset="../assets/img/presentation/1920/01_abe_19.jpg 1920w, ../assets/img/presentation/3840/01_abe_19.jpg 3840w" ></div>
      <div class="img-item"><img src="../assets/img/presentation/1920/01_abe_20.jpg" srcset="../assets/img/presentation/1920/01_abe_20.jpg 1920w, ../assets/img/presentation/3840/01_abe_20.jpg 3840w" ></div>
    </div>
    <router-link class="modal-close is-large" to="/"></router-link>
    <div class="license">無断利用禁止</div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import 'dayjs/locale/ja'
dayjs.locale('ja')
export default {
  name: 'AbeHirosuke',
  methods: {
    afterLeave () {
      this.$root.$emit('triggerScroll')
    },
    checkSessionalStatus (){
      const nowDate = dayjs()
      let   thisSessionalStatus = 'pre';
      if (nowDate.isAfter(this.$store.getters['getStartDate'])) {
        // 開始日以降
        if (nowDate.isBefore(this.$store.getters['getEndDate'])) {
          // 終了日以前
          thisSessionalStatus = 'mid';
        } else {
          // 終了日以降
          thisSessionalStatus = 'post';
        }
      } else {
        // 開始日以前
        thisSessionalStatus = 'pre';
      }
      // メンバープレビュー用
      if (this.$route.name === 'Home-mid') {
        thisSessionalStatus = 'mid';
      } else if(this.$route.name === 'Home-post') {
        thisSessionalStatus = 'post';
      }
      this.$store.dispatch('updateSessionalStatus', thisSessionalStatus)

      // 期間中のみ閲覧できるようにする処理。/midから飛べれば見れる。
      if (thisSessionalStatus !== 'mid') {
        this.$router.push('/');
      }

      return this.$store.getters['getSessionalStatus']
    },
  },
  mounted: function(){
    this.checkSessionalStatus();
  },
  data() {
    return {
      sessionalStatus: this.$store.getters['getSessionalStatus'],
    }
  }
}
</script>